export const callRequest = (request, parameters, axiosConfig) => {
    if (request.length === 3) {
        const castedRequest = request;
        return castedRequest(parameters, axiosConfig);
    }
    const castedRequest = request;
    return castedRequest(axiosConfig);
};
